import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
// SET LANGUAGE
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-CO';
import localeEsExtra from '@angular/common/locales/extra/es-CO';
// redux
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { effectsArray } from './store/effects';
import { appReducers } from './store/app.reducers';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// Capacitor replacements for Ionic Native
// Removido: import { CalendarModule } from 'ion2-calendar';
import { HighchartsChartModule } from 'highcharts-angular';
import { ChartModule } from 'angular-highcharts';


// import { FCM } from '@ionic-native/fcm/ngx';
// import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
// FirebaseX eliminado en favor de Capacitor Push Notifications
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { ComponentsModule } from './components/components.module';
import { UserfilterPageModule } from './pages/modals/userfilter/userfilter.module';
import { CancelappointmentPageModule } from './pages/modals/cancelappointment/cancelappointment.module';
import { PipesModule } from './pipes/pipes.module';
import { environment } from '../environments/environment';

registerLocaleData(localeEs, 'es-ES', localeEsExtra);
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            innerHTMLTemplatesEnabled: true
        }),
        AppRoutingModule,
        ComponentsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        UserfilterPageModule,
        CancelappointmentPageModule,
        PipesModule,
        // Removido: CalendarModule,
        ChartModule,
        HighchartsChartModule,
        StoreModule.forRoot(appReducers),
        EffectsModule.forRoot(effectsArray),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            logOnly: environment.production // Restrict extension to log-only mode
        , connectInZone: true}),
    ],
    providers: [
        // StatusBar: Capacitor plugin used directly
        CurrencyPipe,
        // Keyboard: Capacitor plugin used directly
        // CallNumber: replaced in ToolsService by window.open('tel:') on both platforms
        // SplashScreen: Capacitor plugin used directly
        // FirebaseAnalytics,
        // FCM,
        // Device: @capacitor/device se usa directamente en login
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
